<div class="task-assignment-dialog">

  <div class="dialog-layout">

    <h2 class="dialog-h2">
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.task-assignment-dialog.title"></sc-dictionary-label>
    </h2>


    <div class="dialog-content">
      <div class="task-grid">
        @for (t of tasks; track t; let i = $index) {
          <div class="center cut-content" style="grid-column: 1;" [ngStyle]="{'grid-row': i + 1} ">
            <mat-checkbox [(ngModel)]="t.selected" [ngModelOptions]="{standalone: true}" [disabled]="t.done">
              <sc-dictionary-label [dictionaryKey]="t.nameDictionaryKey"></sc-dictionary-label> (<span
              class="italic">
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.task-assignment-dialog.type.{{t.type}}"></sc-dictionary-label>
            </span>)
          </mat-checkbox>
        </div>
        <mat-form-field style="grid-column: 2;" [ngStyle]="{'grid-row': i + 1}" appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.task-assignment-dialog.relevance"></sc-dictionary-label>
          </mat-label>
          @if (t.type === taskType.CHECK || t.type === taskType.DOCUMENT || t.type === taskType.PICTURE || t.type === taskType.PICTURE_SERIES) {
            <mat-select [(ngModel)]="t.relevance" [disabled]="!t.selected || t.done"
              >
              @for (o of relevanceOptions; track o) {
                <mat-option [value]="o">
                  <sc-dictionary-label dictionaryKey="tmc-yard.ui.task-assignment-dialog.relevance.{{o}}"></sc-dictionary-label>
                </mat-option>
              }
            </mat-select>
          }
          @if (t.type === taskType.MESSAGE) {
            <mat-select [(ngModel)]="t.relevance" [disabled]="!t.selected || t.done"
              >
              @for (o of relevanceOptionsForMessages; track o) {
                <mat-option [value]="o">
                  <sc-dictionary-label dictionaryKey="tmc-yard.ui.task-assignment-dialog.relevance.{{o}}"></sc-dictionary-label>
                </mat-option>
              }
            </mat-select>
          }
          @if (t.type === taskType.ATTRIBUTE_CHANGE) {
            <mat-select [(ngModel)]="t.relevance" [disabled]="!t.selected || t.done"
              >
              @for (o of relevanceOptionsForAttrubteChange; track o) {
                <mat-option [value]="o">
                  <sc-dictionary-label dictionaryKey="tmc-yard.ui.task-assignment-dialog.relevance.{{o}}"></sc-dictionary-label>
                </mat-option>
              }
            </mat-select>
          }
        </mat-form-field>
        @if (processingStatusOptions != null && processingStatusOptions.length > 0) {
          <mat-form-field style="grid-column: 3;" [ngStyle]="{'grid-row': i + 1}"
            appearance="fill">
            <mat-label>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.task-assignment-dialog.processing-status"></sc-dictionary-label>
            </mat-label>
            <mat-select [(ngModel)]="t.processingStatus"
              [disabled]="!t.selected || t.done || (t.relevance !== taskRelevance.AUTOMATICALLY_ON_PROCESSING_STATUS && t.relevance !== taskRelevance.BEFORE_PROCESSING_STATUS)">
              @for (o of processingStatusOptions; track o) {
                <mat-option [value]="o.key">
                  <sc-dictionary-label dictionaryKey="o.dictionaryKey"></sc-dictionary-label>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      }
    </div>
  </div>


  <div class="messages"></div>
  <sc-actionbar>
    <sc-content-spacer grow></sc-content-spacer>
    <sc-cancel-button dictionaryKey="shared.selection-dialog.action.cancel" class="cancel-button" (click)="cancelDialog()"></sc-cancel-button>
    <sc-content-spacer></sc-content-spacer>
    <sc-confirm-button primary (click)="confirm()" class="confirm-button" [disabled]="false"></sc-confirm-button>
  </sc-actionbar>
</div>
</div>
